import React, { useState } from 'react'
import API from '../../API'
import CIcon from '@coreui/icons-react';
import { cilBurn } from '@coreui/icons';
import { CAlert, CButton, CFormInput, CFormLabel, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle, CRow, CCol } from '@coreui/react';

const ModalCambioPassword = (props) => {
  
  const [password, setPassword] = useState(null)
  const [confermaPassword, setConfermaPassword] = useState(null)
  const [errore, setErrore] = useState(null)  

  const inviaDati = async () => {  
    try {
      if (password.trim()=="")
        throw "Definire una password valida"
      if (password != confermaPassword)
        throw "La conferma non coincide"          
      await API.modificaPwdUtente(password)        
      props.close()
    } catch (error) {
      setErrore(error)      
    }    
  }

  return (
    <>
      <CModal visible={props.visible} onClose={props.close} size={props.size}>
        <CModalHeader closeButton className={'bg-info'}>
          <CModalTitle>Cambio Password</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CRow>                        
            <RapidText value={password} set={setPassword} text="Password" />
            <RapidText value={confermaPassword} set={setConfermaPassword} text="Conferma Password" />            
          </CRow>
        </CModalBody>
        <CModalFooter>
          {errore ?
            <CAlert color="danger" className="d-flex align-items-center">
              <CIcon icon={cilBurn} className="flex-shrink-0 me-2" width={24} height={24} />
              <div>
                {errore}
              </div>
            </CAlert> : <></>
          }
          <CButton color="primary" onClick={inviaDati}>Salva</CButton>
          <CButton color="secondary" onClick={props.close}>Chiudi</CButton>
        </CModalFooter>
      </CModal>      
    </>

  )
}

const RapidText = (props) => {
  return (
    <>
      <CCol xs={12}>
        <CFormLabel>{props.text}</CFormLabel>
      </CCol>
      <CCol xs={12}>
        <CFormInput
          value={props.value}
          type="password"
          onChange={(e) => { props.set(e.target.value) }} />
      </CCol>
    </>
  )
}

export default ModalCambioPassword


